// extracted by mini-css-extract-plugin
export default {"useoverview":"DogCardUseOverview_useoverview__ArQmX","usetable":"DogCardUseOverview_usetable__g8BHy"};